import { getRentalLogs, getSMSLogs } from "api/auditApi";
import { getAllInvoices } from "api/invoicesApi";
import { getAllPayments } from "api/paymentsApi";
import { getAllRentals } from "api/rentalApi";
import { getAllUsers } from "api/userApi";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { IAuditApiParams, IFilters, IInvoicesApiParams, IPaymentsApiParams, IRentalApiParams, IUsersApiParams } from "models/interfaces";
import { toggleClearRentalsLogsTableData, toggleClearSmsLogsTableData } from "slices/auditSlice";
import { filters } from "slices/filtersSlice";
import { toggleClearInvoicesTableData } from "slices/invoicesSlice";
import { toggleClearPaymentsTableData } from "slices/paymentsSlice";
import { toggleClearRentalsTableData } from "slices/rentalSlice";
import { toggleClearUsersTableData } from "slices/userSlice";
import moment from "moment";

export const FiltersConfigData = () => {
  const filtersData = useAppSelector<IFilters>(filters);
  const dispatch = useAppDispatch();

  const getAllRentalsApiCall = () => {
    let payload: IRentalApiParams = {
      userFullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      lockerId: filtersData.lockerSelectValue,
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getAllRentals(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearUsersTableData());
      })
  }

  const getAllUsersApiCall = () => {
    console.log("TEST USERS")
    let payload: IUsersApiParams = {
      fullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      userStatus: filtersData.statusTypeValue,
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getAllUsers(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearRentalsTableData());
      })
  }

  const getAllPaymentsApiCall = () => {
    let payload: IPaymentsApiParams = {
      userFullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getAllPayments(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearInvoicesTableData());
      })
  }

  const getAllInvoicesApiCall = () => {
    let payload: IInvoicesApiParams = {
      userFullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getAllInvoices(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearPaymentsTableData());
      })
  }

  const getAllRentalLogsApiCall = () => {
    let payload: IAuditApiParams = {
      fullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      lockerId: filtersData.lockerSelectValue,
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getRentalLogs(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearSmsLogsTableData());
      });
  }

  const getAllSmsLogsApiCall = () => {
    let payload: IAuditApiParams = {
      fullName: {
        usernameOrPhoneNumber: filtersData.searchBarValue
      },
      lockerId: filtersData.lockerSelectValue,
      startDate: filtersData.startDate ? moment(filtersData.startDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      endDate: filtersData.endDate ? moment(filtersData.endDate).format("YYYY-MM-DD HH:mm:ss").toString() : "",
      page: String(filtersData.page)
    }
    dispatch(getSMSLogs(payload))
      .unwrap()
      .then(() => {
        dispatch(toggleClearRentalsLogsTableData());
      });
  }

  return {
    filtersPerPage: {
      rentals: {
        searchBar: true,
        lockerSelect: false,
        reportType: true,
        statusType: false,
        dateRange: true,
        apiCallMethod: () => getAllRentalsApiCall()
      },
      users: {
        searchBar: true,
        lockerSelect: false,
        reportType: false,
        statusType: true,
        dateRange: true,
        apiCallMethod: () => getAllUsersApiCall()
      },
      payments: {
        searchBar: true,
        lockerSelect: false,
        reportType: true,
        statusType: false,
        dateRange: true,
        apiCallMethod: () => getAllPaymentsApiCall()
      },
      invoices_logs: {
        searchBar: true,
        lockerSelect: false,
        reportType: true,
        statusType: false,
        dateRange: true,
        apiCallMethod: () => getAllInvoicesApiCall()
      },
      rentals_logs: {
        searchBar: true,
        lockerSelect: false,
        reportType: true,
        statusType: false,
        dateRange: true,
        apiCallMethod: () => getAllRentalLogsApiCall()
      },
      sms_logs: {
        searchBar: true,
        lockerSelect: false,
        reportType: true,
        statusType: false,
        dateRange: true,
        apiCallMethod: () => getAllSmsLogsApiCall()
      },
    }
  };
};
